import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Extract from '../../pages/difacto/extracts/Extract';
import ExtractsList from '../../pages/difacto/extracts/ExtractsList';
import NewExtract from "../../pages/difacto/extracts/NewExtract";
import EditExtract from "../../pages/difacto/extracts/EditExtract";

function Extracts(props) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={ExtractsList}/>
        <Route exact path={`${path}/new`} component={NewExtract}/>
        <Route path={`${path}/:extractId/edit`} component={EditExtract}/>
        <Route path={`${path}/:extractId`} component={Extract}/>
      </Switch>
    </Suspense>
  )
}

export default Extracts
